var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_792_13060)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1186 11.9959C23.1186 13.5162 22.3325 14.8528 21.0221 15.5995L7.04011 23.4618C6.39802 23.8291 5.70347 23.9993 5.00893 23.9993C4.28846 23.9993 3.58079 23.8157 2.92561 23.4356C1.64147 22.6754 0.881348 21.3522 0.881348 19.8716V4.1336C0.881348 2.65301 1.64147 1.31641 2.92561 0.569695C4.20975 -0.177633 5.7428 -0.19043 7.04007 0.530039L21.0221 8.40579C22.3325 9.13971 23.1186 10.4891 23.1186 11.9959Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_792_13060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 -0.000732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e0e1f9c516e5c97dc2e37bd25291443e.svg";
export { ForwardRef as ReactComponent };